/**
 * Coarse mobile check: used to pick the Telegram mini-app deep link over the web feed, and by the
 * server — given the request's `User-Agent` — to guess the layout a page is first rendered in
 * (`root.tsx`). Without an argument it reads the browser's own.
 */
export const isMobileDevice = (userAgent?: string): boolean => {
  const agent = userAgent ?? (typeof navigator === 'undefined' ? '' : navigator.userAgent);

  return /Mobi|Android|iPhone|iPad|iPod/i.test(agent);
};

/**
 * Whether the server takes a request for a laptop's: wide unless its `User-Agent` is a phone's.
 * The document's layout (`root.tsx`) and what is asked of the api for it — the lists of the filter
 * column, which only a wide page shows — follow the one guess.
 */
export const isWideRequest = (request: Request): boolean => !isMobileDevice(request.headers.get('user-agent') ?? '');

/** Minimal email shape guard for the registration form (the server is authoritative). */
export const isValidEmail = (email: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
